import React from 'react';

export const SafetyDutyModal = ({ onSave, onClose }) => (
  <div
    className='dialog-md dialog--modal'
    onClick={e => {
      e.stopPropagation();
    }}
  >
    <div className='dialog-md__body'>
      選択期間中の安全当番を全て変更します。
      <br />
      よろしいですか？
    </div>
    <div className='dialog-md__footer'>
      <button className='btn-fixedsize--effective' onClick={onSave}>
        変更
      </button>
      <button className='btn-fixedsize--sub' onClick={onClose}>
        戻る
      </button>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/SafetyDutyModal.jsx